<template>
  <div
    class="container"
  >
    <h3 class="is-margin-top-0">{{$t('ui.lead_mask_editor.basic_config')}}</h3>
    <div class="row gutter-md">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <form class="lead-mask-update--form max-width" @submit.prevent="update">
          <div class="has-gutter-l">
            <field :errors="errors" model="lead_mask" name="name" v-model="item.name" placeholder="Lead Sheet Name"></field>
            <field :required="true" :errors="errors" model="lead_mask" name="language" type="select" v-model="item.language" placeholder="English" :collection="selectableLanguages" ></field>
          </div>
          <div class="alwaysHidden">
            <field :errors="errors" model="lead_mask" v-can="'organization.list'" name="organization" v-model="item.organization_id" type="select" :params="{no_i18n: true}" :collection="organizations"></field>
          </div>
        </form>
      </div>
    </div>
    <div class="lead-mask-raw" v-can="'is_root'">
      <div class="lead-mask-raw--title" @click="isRawDisplayed=!isRawDisplayed">
        <i class="icon yule-icon-chevron-down" v-if="isRawDisplayed"></i>
        <i class="icon yule-icon-chevron-right" v-else></i>
        {{$t('ui.lead_mask_editor.see_raw')}}
      </div>
      <div class="lead-mask-raw--content" v-show="isRawDisplayed">
        <field :errors="errors" @input="structureChange" model="lead_mask" name="structure" type="textarea" :value="structure" placeholder="{json}"></field>
      </div>
    </div>
    <page-saver
      class="page-saver-wrapper"
      @save="update"
      @cancel="cancel"
    />
  </div>
</template>
<script>
import Api from '@/api/LeadMask.js'
import OrganizationApi from '@/api/Organization.js'
import LeadMaskConfiguration from './LeadMaskConfiguration'
import Permission from '@/classes/Permission'
import PageSaver from '@/components/helpers/Layout/PageSaver'
import languages from '@/config/data/languages'
import Field from '@/components/helpers/DataInput/Field'
import {diff} from 'deep-object-diff'
import Ui from '@/classes/Ui'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    LeadMaskConfiguration,
    PageSaver,
    Field
  },
  data() {
    return {
      api: new Api(),
      errors: [],
      isRawDisplayed: false,
      organizations: [],
      languages: languages,
      tempItem: {}
    }
  },
  computed: {
    currentLanguage: {
      get () {
        return this.$store.getters.getCurrentLanguage
      }
    },
    unsavedChanges() {
      // Diff item and item_saved
      return this.generateDiffLength(this.item, this.item_saved) > 0
    },
    structure(){
      return JSON.stringify(this.item.structure)
    },
    configuration() {
      return JSON.stringify(this.item.configuration)
    },
    additional_data() {
      return JSON.stringify(this.item.additional_data)
    },
    selectableLanguages() {
      let language = this.currentLanguage || "en";
      let translatedLangs = [];
      let selectedLanguage = this.languages[language];

      if (!selectedLanguage) {
        selectedLanguage = this.languages['en'];
      }

      selectedLanguage.forEach(lang => {
        translatedLangs.push(lang);
      });

      return translatedLangs;
    },
  },
  async mounted() {
    this.retrieve_associations()
    this.setupHeader()
    this.tempItem.name = this.item.name
    this.tempItem.language = this.item.language
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      let shouldContinue = window.confirm(this.$t('ui.drag_editor.popup.unsaved_changes'))
      next(shouldContinue)
    } else {
      next()
    }
  },
  methods: {
    setupHeader() {
      Ui.setHeaderButtons([])
    },
    generateDiffLength(itemOne, itemTwo) {
      let diffObj = diff(itemOne, itemTwo)
      // We delete these since you edit them separately in the editor
      delete diffObj.unpublished_structure
      delete diffObj.structure
      return Object.keys(diffObj).length
    },
    update() {
      this.$emit('update', this.item)
    },
    structureChange(val){
      try {
        this.item.unpublished_structure = JSON.parse(val)
        this.item.structure = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "structure"})
      }
    },
    configurationChange(val){
      try {
        this.item.configuration = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "configuration"})
      }
    },
    additional_dataChange(val){
      try {
        this.item.additional_data = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "additional_data"})
      }
    },
    retrieve_associations(){
      let permission = Permission.loadPermissions()

      if(Permission.can(permission, 'organizations.list')){
        let api = new OrganizationApi()
        api.all_for_association().then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error)
        })
      }
    },
    cancel() {
      this.item.name = this.tempItem.name
      this.item.language = this.tempItem.language
    }
  }
}
</script>



// WEBPACK FOOTER //
// LeadMaskOptions.vue?10e2cb96